/**
 * Created by User on 10/5/2016.
 */
import PageComponent from '../base/PageComponent';

export default class PropertyList extends PageComponent {
    updateListings(html){
        $(this.element).html(html);
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/PropertyList.js